/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Logger } from 'fsts';
import { namespace } from 'vuex-class';
import gsp, {
  GspUserRoleDetail,
  GspUserRoleDetailInner,
  GspUserRoleDetailModuleRole,
} from '@/shared/model/gspUserRoleDetail';
import { RoleOperation } from '@/shared/utils/Constants';
import { GspUserRole } from '@/shared/model/gspUserRole';
import GeneralUtils, { deepClone, delay } from '@/shared/utils/generalUtils';
import { OdataItems } from '@/shared/model/OdataItems';
import { GspRole } from '@/shared/model/gspRole';
import { VBtn } from 'vuetify/lib';
import EditMultipleModuleRolesDialog from './edit-multiple-module-roles/edit-multiple-module-roles.vue';
import { UserActionType } from '@/shared/model/userActionsUserRoleChanges';
import { CountryUtils } from '@/shared/utils/countryUtils';
import { Country } from '@/shared/model/country.model';
import { email } from 'vee-validate/dist/rules';
import { GspServiceKey } from '@/shared/utils/constants/services';

const logger = new Logger('module-role-table');
const authModule = namespace('auth');
const contactModule = namespace('contact');
const companyModule = namespace('company');
const gspRoleModule = namespace('gspRole');
const gspUserRoleModule = namespace('gspUserRole');
const gspServiceModule = namespace('gspService');
const gspUserRoleDetailModule = namespace('gspUserRoleDetail');
const contactPanelModule = namespace('contactPanel');
const entraJobsModule = namespace('entraJobs');

export interface VmeRole {
  id: number;
  key: string;
  label: string;
}

export const VME_ROLES: VmeRole[] = [
  { id: 42, key: 'chef', label: 'Chef (Bonusabrechnungen, Direktbonus)' },
  { id: 43, key: 'konddirbonus', label: 'Konditionen (Direktbonus)' },
  { id: 44, key: 'kondbonus', label: 'Konditionen (Bonus, ohne Direktbonus)' },
  { id: 45, key: 'kond', label: 'Konditionen (Rabatte)' },
  { id: 46, key: 'logistik', label: 'Konditionen (Logistik-Info)' },
];




@Component({
  components: { VBtn, EditMultipleModuleRolesDialog },
})
export default class ModuleRoleTable extends Vue {
  // Delay before first request in rapid-click sequence
  private readonly QUEUE_INITIAL_DELAY_MS = 3000;
  // Delay between queued requests
  private readonly QUEUE_BETWEEN_REQUESTS_MS = 450;


  @authModule.Getter('getEnvironment')
  private getEnvironment: any;

  @gspServiceModule.Action('getGspServices')
  private actionGetGspServices!: any;
  @gspUserRoleModule.Action('addRoleFromBackend')
  private actionAddRoleFromBackend!: any;
  @gspUserRoleModule.Action('addRoleDetailFromBackend')
  private actionAddRoleDetailFromBackend!: any;
  @gspUserRoleDetailModule.Action('getGspUserRoleDetail')
  private actionGetGspUserRoleDetail!: any;
  @gspUserRoleDetailModule.Action('updateGspUserRoleDetail')
  private actionUpdateGspUserRoleDetail!: any;
  @gspUserRoleDetailModule.Action('addUserFromManageMaxService')
  private actionAddUserFromManageMaxService!: any;
  @gspUserRoleDetailModule.Action('deleteUserFromManageMaxService')
  private actionDeleteUserFromManageMaxService!: any;
  @gspUserRoleDetailModule.Action('updateGspUserRoleDetailMultipleRoles')
  private actionUpdateGspUserRoleDetailMultipleRoles!: any;

  @gspUserRoleDetailModule.Action('getWarengruppeForMax')
  private actionGetWarengruppeForMax!: any;

  @gspUserRoleModule.Action('updateGspUserRole')
  private actionUpdateGspUserRole!: any;
  @gspUserRoleModule.Getter('getGspUserRoles')
  private userRoles!: any;
  @gspUserRoleModule.Action('updateIsProcessingRoles')
  private updateIsProcessingRoles!: any;

  @contactModule.Action('getMasterZrGsp')
  private actionGetMasterZrGsp!: any;

  @contactPanelModule.Action('updateContactPanel')
  private actionUpdateContactPanel!: any;
  @contactPanelModule.Action('deleteContactPanel')
  private actionDeleteContactPanel!: any;


  @gspRoleModule.Getter('getGspRoles')
  private gspRoles!: OdataItems<GspRole>;

  @contactModule.Getter('getCompanyZrs')
  private companyZrNums!: any;
  // AD-313 shared `rolle_markenportfolio_allgemein` checks live in the Contact vuex module getters
  @contactModule.Getter('hasRoomioInMarkenportfolio')
  private hasRoomioInMarkenportfolio!: (zrNumbers: any) => boolean;
  @contactModule.Getter('hasTrendhopperInMarkenportfolio')
  private hasTrendhopperInMarkenportfolio!: (zrNumbers: any) => boolean;

  @contactModule.Action('addCustomer')
  private actionAddCustomer!: any;
  @contactModule.Action('deleteCustomer')
  private actionDeleteCustomer!: any;
  @companyModule.Action('getCompany')
  private actionGetCompany!: any;


  @entraJobsModule.Action('syncSharepointGroups')
  actionSyncSharepointGroups!: (data: any) => Promise<any>;


  @Prop()
  private serviceModules!: any;
  @Prop()
  private zrNumberArr!: any;
  @Prop({ default: false })
  private noAccess!: boolean;

  @Prop()
  private userRole!: GspUserRole;
  @Prop()
  private service!: any;
  @Prop()
  private serviceModuleCommonText!: any;
  @Prop()
  private contactId!: any;
  @Prop()
  private contactData!: any;
  @Prop()
  private contactEmail!: any;
  @Prop()
  private isSingleRow!: boolean;

  moduleZrNumArr: GspUserRoleDetailInner[] = [];
  moduleZrNumArrBackup: GspUserRoleDetailInner[] = [];

  editMultipleModuleRolesDialog: {
    dialog: boolean;
    editedUserRoleDetails: GspUserRoleDetailInner[];
  } = {
      dialog: false,
      editedUserRoleDetails: [],
    };

  // private async getGspServices() {
  //   await this.actionGetGspServices()
  //     .then((result: any) => {
  //       this.servicesArr = result.value;
  //     })
  //     .catch((err: any) => {
  //       logger.error(err);
  //     });
  // }
  servicesArr: any = [];
  // modulesArr: any = [];
  // attributesArr: any = [];

  get queueConfig() {
    if (this.service?.key === GspServiceKey.ZrPortal) {
      return {
        initialDelay: 1000,
        betweenDelay: 250,
      };
    }

    return {
      initialDelay: this.QUEUE_INITIAL_DELAY_MS,
      betweenDelay: this.QUEUE_BETWEEN_REQUESTS_MS,
    };
  }

  get isHaveCommonModules() {
    return this.serviceModules?.filter((x: any) => x.isCommon).length > 1;
  }

  get roleServices() {
    return this.roles?.map((x: any) => x.id);
    // return this.userRole?.gspUserRoleDetails.map((x:any) => x.serviceId);
  }

  get isGspService() {
    // return this.serviceId == 5; // !! (AD-103) bad approach since `serviceId` position can change (encounter in Prod) and Service can be easily renamed, so for now just use `GetMasterZrGsp` logic for Services where multiple ZrNummer used (only GSP for now (on 2024-06))
    // (AD-103) decided to use separate backend field in GspService table
    return this.service.is_call_zr_master;
  }


  get isMaxService() {
    console.log('zz this.service.key :>> ', this.service.key);
    // console.log('this.service.key == max GspServiceKey:>> ', this.service.key == GspServiceKey.ManageMax);
    // console.log('this.service.name?.toLowerCase().includes(managemax) :>> ', this.service.name?.toLowerCase().includes('managemax'));
    return this.service.key == GspServiceKey.ManageMax;
  }
  get isVmeAcademyService() {
    return this.service.key == GspServiceKey.VmeAkad;
  }
  get isVmeCommunityService() {
    return this.service.key == GspServiceKey.VmeComm;
  }
  get isZrBiService() {
    return this.service.key == GspServiceKey.ZrStat; // former `ZRBI`
  }
  get isZrStatNewService() {
    return this.service.key == GspServiceKey.ZrStatNew; // former `ZRBI`
  }

  /** (AD-304)
   * Whether this service should expand ZR numbers to include Master ZRs.
   * Applicable to GSP (via backend flag) and ZR-Statistik (ZrStat).
   */
  get shouldUseMasterZrExpansion(): boolean {
    return Boolean(this.service?.is_call_zr_master) || this.isZrStatNewService; // AD-305 cancel `zrMaster` logic for `this.isZrBiService`
  }

  private hasAnySelectedRoles(): boolean {
    return this.moduleZrNumArr?.some((row: any) => row.moduleRoles?.some((module: any) => module.roles?.length > 0));
  }

  private normalizeLegacyZrStatRoleDetails(roleDetails: GspUserRoleDetailInner[]): GspUserRoleDetailInner[] {
    if (!this.isZrBiService || !roleDetails?.length) {
      return roleDetails;
    }

    const legacyRow: any = roleDetails[0];
    const isLegacySingleRow =
      roleDetails.length === 1 &&
      !legacyRow?.zrNummer &&
      !!legacyRow?.zrNummerAll;

    if (!isLegacySingleRow) {
      return roleDetails;
    }

    const zrsFromRoleDetails = (legacyRow.zrNummerAll as string)
      .split(',')
      .map((x: string) => x.trim())
      .filter((x: string) => !!x);

    // (AD-304) Fallback now also includes master ZR numbers (same list used everywhere else for this
    // service, see `isGspService`/`zrNumberArrWithMaster`), so legacy records without a saved
    // `zrNummerAll` still end up with the SAME OR MORE ZR numbers than `contact.companyZrNumber`,
    // consistent with the rest of the ZR-Statistik logic.
    const fallbackZrs = (this.zrNumberArrWithMaster || [])
      .map((x: any) => `${x}`.trim())
      .filter((x: string) => !!x);

    const zrs = zrsFromRoleDetails.length > 0 ? zrsFromRoleDetails : fallbackZrs;

    return zrs.map((zr: string) => ({
      zrNummer: zr,
      moduleRoles: (legacyRow.moduleRoles || []).map((module: any) => ({
        ...module,
        roles: [...(module.roles || [])],
      })),
    }));
  }

  get intranetKonditionModule() {
    return this.moduleZrNumArr[0].moduleRoles?.find(x => x.name?.toLowerCase().includes("konditionen"))
  }

  /** (AD-313) (2026-10) `Roomio` values (roles in the autocomplete) are shown only if `rolle_markenportfolio_allgemein`
   * (lowercased) contains `roomio` for the Contact companies (`contact.companyZrNumber` - EVERY ZR number is
   * checked, it is enough that EVEN 1 company has the value). Logic lives in the Contact vuex getter
   * `hasRoomioInMarkenportfolio`; this computed caches the result per `module-role-table` instance. */
  get showRoomioRoles(): boolean {
    return this.hasRoomioInMarkenportfolio(this.zrNumberArr);
  }

  /** (AD-313) (2026-10) same as `showRoomioRoles` for `Trendhopper` values (`rolle_markenportfolio_allgemein` contains `trendhopper`) */
  get showTrendhopperRoles(): boolean {
    return this.hasTrendhopperInMarkenportfolio(this.zrNumberArr);
  }


  get noMaxAccessWithoutWaren() {
    return this.isMaxService && this.warmax.length == 0;
  }

  get zrNumberArrWithMaster() {
    if (this.shouldUseMasterZrExpansion) {
      let res = [...new Set(this.zrNumberArr.concat(this.zrMasterGsp))];
      return res;
    }
    return this.zrNumberArr;
  }

  currentRoleDetail?: GspUserRoleDetail = gsp.parse({});
  currentRoleDetailInit?: GspUserRoleDetail = gsp.parse({}); // to compare initial and changed role to log added/deleted role in database

  async created() {
    // console.log('zzz this.getEnvironment :>> ', this.getEnvironment);
    var promiseAll = [this.getMasterZrForGsp()];
    if (this.isMaxService) {
      promiseAll.push(this.getWarengruppeForMax());
    }
    await Promise.all(promiseAll);
  }

  get vmeRoles(): VmeRole[] {
    if (this.getEnvironment?.toLowerCase() === 'production') {
      return [
        { id: 46, key: 'chef', label: 'Chef (Bonusabrechnungen, Direktbonus)' },
        { id: 47, key: 'konddirbonus', label: 'Konditionen (Direktbonus)' },
        { id: 48, key: 'kondbonus', label: 'Konditionen (Bonus, ohne Direktbonus)' },
        { id: 49, key: 'kond', label: 'Konditionen (Rabatte)' },
        { id: 50, key: 'logistik', label: 'Konditionen (Logistik-Info)' },
      ];
    }

    return VME_ROLES;
  }



  zrMasterGsp: any = [];
  private dataLoaded = false;
  initComponent() {
    this.logicFromMounted();
    this.dataLoaded = true;
  }


  //#region (AD-197 Warengrupp for Managemax logic)
  private warmax: any = [];
  private warmaxPrevious: any = [];
  private maxWarengruppe: any = [];
  private warenBackendAction = '';
  private warenDiff = '';
  async getWarengruppeForMax() {
    await this.actionGetWarengruppeForMax(this.contactEmail).then((result: any) => {
      console.log('result :>> ', result);
      this.maxWarengruppe = result.war ? JSON.parse(result.war) : [];//.filter((x: any)=> !x.ParentId)
      if (result.user && result.user.length > 4) { // empty array has length 2
        console.log('objeresult.userct :>> ', result.user);
        let user = JSON.parse(result.user);
        console.log('user :>> ', user);
        if (user[0]?.Warengruppen) {
          this.warmax = user[0]?.Warengruppen;
          this.warmaxPrevious = [...this.warmax];
        }
      }
      // .sort((a: any, b:any) => a.Id > b.Id ? 1 : -1);
      console.log('this.maxWarengruppe :>> ', this.maxWarengruppe);
    }).catch((err: any) => {
      logger.error(err);
    });
  }

  get isManageMaxHasRole() {
    return this.isMaxService && !!this.currentRoleDetail && (this.currentRoleDetail?.roleDetails[0] as any)?.moduleRoles[0]?.roles?.length > 0;
  }
  //#region (AD-267) Calculate `UserGroupId` for `ManageMax`
  get currentRoleDetailRoles() {
    return (this.currentRoleDetail?.roleDetails[0] as any)?.moduleRoles[0]?.roles;
  }

  get manageMaxUserGroupId(): number {
    const currentRoles = this.currentRoleDetailRoles;

    // If No roles, default to 1
    if (!currentRoles || currentRoles.length === 0) {
      return 1;
    }

    // Check if ANY of the role IDs map to a role with "admin" in the name
    const hasAdminRole = currentRoles.some((roleId: number) => {
      const role = this.gspRoles.items.find((r: any) => r.id === roleId);
      return role?.name && role.name.toLowerCase().includes('admin');
    });

    return hasAdminRole ? 8 : 1;
  }
  //#endregion

  getWarenGruppeAction() {
    let currentWaren = this.warmax;
    let previousWaren = this.warmaxPrevious;

    let action = ''; // 5 4
    let diffResult = currentWaren.length - previousWaren.length;
    let warenDifference = [];
    console.log('currentWaren.length :>> ', currentWaren.length);
    console.log('previousWaren.length :>> ', previousWaren.length);
    console.log('diffResult :>> ', diffResult);

    if (diffResult == 1) {
      action = 'AddWarengruppe';
      warenDifference = currentWaren.filter((x: any) => !previousWaren.includes(x));
    } else if (diffResult == -1) {
      action = 'DeleteWarengruppe';
      warenDifference = previousWaren.filter((x: any) => !currentWaren.includes(x));
    } else if (diffResult > 1 || currentWaren.length == this.maxWarengruppe.length) {
      action = 'AddAllWarengruppe';
    } else if (diffResult < -1 || previousWaren.length == 0) {
      action = 'DeleteAllWarengruppe';
    } else if (diffResult == 0) {
      // (AD-197) on creation roleDetail
      action = 'AddWarengruppe';
      warenDifference = currentWaren;
    }

    console.log(' action :>> ', action);
    console.log('warenDifference :>> ', warenDifference);
    if (warenDifference.length > 0) {
      let resx = this.getWarrenNameIdPair(warenDifference[0]);
      console.log('waraa :>> ', resx);
    }

    this.warenDiff = this.getWarrenNameIdPair(warenDifference);
    console.log('this.warenDiff :>> ', this.warenDiff);
    this.warmaxPrevious = this.warmax;
    this.warenBackendAction = action;
    return action;
  }

  getMaxDeleteWarenAction() {
    let currentWaren = this.warmax;
    let previousWaren = this.warmaxPrevious;
    let action = 'DeleteWarengruppe';

    if (previousWaren.length > 1 || currentWaren.length == 0) {
      action = 'DeleteAllWarengruppe';
    }
    this.warenBackendAction = action;
    this.warenDiff = this.getWarrenNameIdPair([]);

    return action;
  }

  changeWarMax(v1: any) {
    console.log('v1 :>> ', v1);
    console.log(' this.currentRoleDetailInit :>> ', this.currentRoleDetail);

    // let isMaxHasRole = !!this.currentRoleDetail && (this.currentRoleDetail?.roleDetails as GspUserRoleDetailInner[])?.some(x => x.moduleRoles && x.moduleRoles?.length > 0 && x.moduleRoles[0].roles && x.moduleRoles[0].roles?.length > 0);
    // let isMaxHasRole = !!this.currentRoleDetail && (this.currentRoleDetail?.roleDetails[0] as any)?.moduleRoles[0]?.roles?.length > 0;
    console.log('isMaxHasRole :>> ', this.isManageMaxHasRole);
    // let warenWithNames = this.warMaxWithName();

    console.log('this.warmax :>> ', this.warmax);
    console.log('this.warmaxPrevious :>> ', this.warmaxPrevious);
    this.getWarenGruppeAction();

    if (this.isManageMaxHasRole) {
      const maxPayload = {
        contactId: this.contactId,
        contactEmail: this.contactEmail,
        firstName: this.contactData.firstName,
        lastName: this.contactData.lastName,
        UserGroupId: this.manageMaxUserGroupId,  // 2026-04 (!! change) if `basis` 1, if `admin-` 8 // discussed with Chaslau (for now always 1)
        zrNummernCsv: this.zrNumberArr?.join(',') + '',
        azureUserId: this.contactData.contactAzureId,

        azureGroupId: this.service.entra_Group,

        gspUserRoleId: this.currentRoleDetail?.id,
        serviceId: this.service.id,
        warengruppen: this.warmax,
        // warengruppenWithName: warenWithNames,
        actionType: this.warenBackendAction,
        warenDiff: this.warenDiff
      }
      console.log('maxPayload :>> ', maxPayload);
      this.actionAddUserFromManageMaxService(maxPayload);
    }
    // (AD-197) remove `ManageMax` role if manually remove last Warengruppe
    if (v1.length == 0) {
      this.manuallyRemoveManageMaxRole();
    } else if (!this.isManageMaxHasRole) {
      // (AD-197) manually create role if Warengruppe was selected before role
      this.manuallyAddManageMaxRole();
    }
  }



  get selectAllWarengruppe() {
    return this.warmax.length === this.maxWarengruppe.length;
  }

  get selectSomeWarengruppe() {
    return this.warmax.length > 0 && !this.selectAllWarengruppe;
  }

  get iconForAllWarengruppe() {
    if (this.selectAllWarengruppe) return 'mdi-close-box';
    if (this.selectSomeWarengruppe) return 'mdi-minus-box';
    return 'mdi-checkbox-blank-outline';
  }

  manuallyAddManageMaxRole() {
    let item = (this.currentRoleDetail?.roleDetails[0] as any)?.moduleRoles[0];
    console.log('this.userRole :>> ', this.userRole);
    console.log('this.currentRoleDetail :>> ', this.currentRoleDetail);
    console.log('this.currentRoleDetailInit :>> ', this.currentRoleDetailInit);
    console.log('item :>> ', item);
    if (!item) {
      let item2 = this.moduleZrNumArr.find((x: any) => x.moduleRoles.some((m: any) => m.name.toLowerCase().includes('managemax')))?.moduleRoles;
      let item3 = item2?.find((m: any) => m.name.toLowerCase().includes('managemax'));

      if (item3) {
        item = item3;
      }
    }

    let roles = [this.roleServices[0]];
    console.log('roles :>> ', roles);
    item.roles = roles;
    if (roles.length > 0 && this.roleServices[0]) {
      this.changeModuleRole(roles, item, undefined);
    }

  }
  manuallyRemoveManageMaxRole() {
    let item = (this.currentRoleDetail?.roleDetails[0] as any)?.moduleRoles[0];
    item.roles = []; // delete roles for ManageMax if remove all `Warengruppe`
    this.changeModuleRole([], item, undefined);
  }

  toggleAllWarenGruppe() {
    this.$nextTick(() => {
      if (this.selectAllWarengruppe) {
        this.warmax = [];
        this.getWarenGruppeAction();
        this.manuallyRemoveManageMaxRole();
      }
      else {
        this.warmax = this.maxWarengruppe.map((x: any) => x.Id);
        // this.reportParams.employeeId = this.employees
        //   .map((x: any) => x.id)
        //   .slice();
        this.changeWarMax(this.warmax);
      }
    });
  }

  getWarrenNameIdPair(array: Array<any>) {
    let result = '';
    if (array.length > 0) {
      const id = array[0];
      let warrenRecord = this.maxWarengruppe.find((x: any) => x.Id == id);
      console.log('getWarrenNameIdPairById warrenRecord:>> ', warrenRecord);
      result = `${warrenRecord.Name};;;${warrenRecord.Id}`
    } else {
      let number = this.warmax.length == this.maxWarengruppe.length || this.warmax.length == 0 ? this.maxWarengruppe.length : this.warmax.length;

      result = `Alle ${number}`;
    }

    return result;
  }

  warMaxWithName() {
    console.log(' this.maxWarengruppe :>> ', this.maxWarengruppe);
    console.log('this.warmax :>> ', this.warmax);


    let filter22 = this.maxWarengruppe.filter((x: any) => this.warmax.includes(x.Id));
    console.log('filter22 :>> ', filter22);
    let filter = this.maxWarengruppe.filter((x: any) => this.warmax.includes(x.Id)).map((x: any) =>
      ({ id: x.Id, name: x.Name })
    );
    console.log(' war warMaxWithName filter :>> ', filter);
    return filter;
  }
  //#endregion

  async getMasterZrForGsp() {
    if (!this.shouldUseMasterZrExpansion) {
      this.initComponent();
      return;
    }
    // console.log(this.contact.companyZrNumber)
    let zrArray = this.zrNumberArr;
    // zrArray = zrArray.map(x=> x.trim());
    await this.actionGetMasterZrGsp(zrArray)
      .then((result: any) => {
        console.log('actionGetMasterZrGsp result :>> ', result.result);
        let resArr = result.result;
        //let difference = arr1.filter(x => !arr2.includes(x));
        let diff = resArr.filter((x: any) => !zrArray.includes(x));
        console.log('diff :>> ', diff);
        this.zrMasterGsp = diff;
      })
      .catch((err: any) => {
        logger.error(err);
      })
      .finally(() => this.initComponent());
  }

  @Watch('userRole')
  onUserRoleUpdated() {
    logger.debug('----userRoleUpdated----');
    this.getMasterZrForGsp();
  }

  // Re-sync the copied RoleDetails display data when the parent service-module cache changes.
  @Watch('serviceModules', { deep: true })
  private onServiceModulesChanged() {
    console.log('[vue2] onServiceModulesChanged: moduleZrNumArr length :>> ', this.moduleZrNumArr?.length);
   
    if (!this.moduleZrNumArr?.length || !this.serviceModules?.length) return;

    const commonModuleNames = this.serviceModules
      .filter((module: any) => module.isCommon)
      .map((module: any) => module.name);
    const moduleMap = new Map(this.serviceModules.map((module: any) => [module.id, module]));
    console.log('[vue2] moduleMap>> ', moduleMap);
    this.moduleZrNumArr.forEach((row: any) => {
      row.moduleRoles?.forEach((dbModule: any) => {
        const match: any = moduleMap.get(dbModule.id);
        if (match) {
          const currentName = match.isCommon && commonModuleNames.length > 1
            ? commonModuleNames.join(',')
            : match.name;

          // Vue 2 needs `$set` to react to this nested RoleDetails name update (reactivity rules)
          this.$set(dbModule, 'name', currentName);
          this.$set(dbModule, 'tooltip', match.tooltip);
        }
      });
    });
  }


  async mounted() {
    // var promiseAll = [this.getGspServices()];
    // await Promise.all(promiseAll);
    // // const result = this.userRoles.items.find((role:any) => role.contactEmail == this.contact.email);
    // // console.log('mounted userRole result :>> ', result);
    // // console.log('mounted  contact:>> ', this.contact.email);
    // if (this.userRole?.zrNumRolesData) {
    //   this.userRoleData = JSON.parse(this.userRole?.zrNumRolesData);
    //   this.userRoleData.forEach((element: any, index) => {
    //     if (element?.zrNummer) {
    //       Vue.set(this.boxes, index, true);
    //       Vue.set(this.roleBoxes, index, element.roles);
    //     }
    //   });
    //   this.userRolesPayload = this.userRoleData;
    // }
  }

  private static readonly _warnedModules = new Set<string>();
  private commonModules: any = {}; // (AD-194) for Add/Delete user from AzureGroup based on `entra_Group` for common Modules
  logicFromMounted() {
    this.currentRoleDetail = this.userRole?.gspUserRoleDetails.find((x: any) => x.serviceId === this.service.id);
    this.currentRoleDetailInit = this.currentRoleDetail != undefined ? deepClone(this.currentRoleDetail) : undefined;

    // console.log('zz 3 this.currentRoleDetail :>> ',  this.currentRoleDetail);
    console.log('zz this.currentRoleDetail ID :>> ', this.currentRoleDetail?.id);
    // this.serviceModules.forEach((el:any, index: number) => {
    //   this.moduleZrNumArr.push({'zrNummer': this.zrNumberArr[index],'module': el})
    // })
    //console.log('zz this.userRole :>> ', this.userRole);
    // console.log('this.serviceModules OA:>> ', Object.assign({}, this.serviceModules));
    let modules = this.serviceModules;
    // console.log('this.serviceModules common init :>> ', Object.assign({},this.serviceModules));
    // console.log('zzz this.serviceModules :>> ', this.serviceModules);

    if (this.isHaveCommonModules) {
      // if (this.serviceModules.length > 1 && this.serviceModules[0].name.includes(this.serviceModules[1].name)) {
      //   console.log('already all common modules concatenated :>> ');
      //   // (AD-95) fix bug that `common` long modules string is duplicated for each new Contact (without created role)
      //   modules = [this.serviceModules[0]];
      //   console.log('modules ex :>> ', modules);
      // } else {
      const result = this.serviceModules.reduce((acc: any, cur: any) => {
        // console.log('acc :>> ', Object.assign({},acc));
        //  console.log('cur :>> ', Object.assign({},cur));
        let doesExist = acc.find((a: any) => a.isCommon);
        // console.log('object :>> ', object);
        // console.log('doesExist :>> ', Object.assign({},doesExist));

        if (doesExist && cur.isCommon) {
          if (!doesExist.name.includes(cur.name)) {
            doesExist.name = `${doesExist.name},${cur.name}`;
            doesExist.isCommon = true;
          }

          if (!!cur.entra_Group && (!doesExist.entra_Group || !doesExist.entra_Group.includes(cur.entra_Group))) {
            doesExist.entra_Group = `${doesExist.entra_Group},${cur.entra_Group}`;
            doesExist.isCommon = true;
          }
        } else {
          acc.push({ ...cur }); // Keep common-module grouping local; do not mutate objects owned by the Vuex-backed prop : was just `cur` before`
        }
        return acc;
      }, []);
      modules = result;
      this.commonModules = result;
      // }
    }

    const roleDetails =
      this.currentRoleDetail && this.currentRoleDetail.roleDetails && this.currentRoleDetail.roleDetails.length > 0;

    this.moduleZrNumArr = [];
    // console.log('before    this.moduleZrNumArr:>> ',   this.moduleZrNumArr );

    // (AD-264) hide OLD modules for `Intranet` service
    modules = this.hideBlockverrechnungAndSpotMarktForIntranet(modules);
    if (this.userRole?.id && this.userRole.gspUserRoleDetails.length > 0 && roleDetails) {
      // console.log('zzz userRole exist :>> ', );
      //console.log('this.currentRoleDetail!.roleDetails :>> ', this.currentRoleDetail!.roleDetails);
      // !! TODO(AD-89) decide how to read existing data if Modules `IsCommon` checkbox was changed
      this.moduleZrNumArr = this.normalizeLegacyZrStatRoleDetails(
        this.currentRoleDetail!.roleDetails as GspUserRoleDetailInner[]
      );
      this.currentRoleDetail!.roleDetails = this.moduleZrNumArr;
      if (this.currentRoleDetailInit) {
        this.currentRoleDetailInit.roleDetails = deepClone(this.moduleZrNumArr);
      }
      // console.log('parse this.currentRoleDetail!.roleDetails:>> ', JSON.stringify(this.currentRoleDetail!.roleDetails));
      // console.log('parse :>> ', JSON.stringify(this.moduleZrNumArr));
      // console.log('after    this.moduleZrNumArr:>> ',   this.moduleZrNumArr );
      // (AD-289) Point 4 if somehow wrong modules will be in database `"GspUserRoleDetails"` table `RoleDetails` column (like `Bonus` and `Gutschriften` for ZrPortal), then filter them out (HIDE)
      this.moduleZrNumArr.forEach((row: any) => {
        if (row.moduleRoles) {
          row.moduleRoles = row.moduleRoles.filter((m: any) => {
            return this.rolesWithModuleFilter(m).length > 0;
          });
        }
      });

      //console.log('this.moduleZrNumArr LEN :>> ', this.moduleZrNumArr.length);
      // console.log('this.this.zrNumberArrWithMaster.length :>> ', this.zrNumberArrWithMaster.length);
      if (this.zrNumberArrWithMaster.length > this.moduleZrNumArr.length && this.shouldUseMasterZrExpansion) {
        let currentZrs = this.moduleZrNumArr.map((x: any) => x.zrNummer + ''); // (AD-0) convert `moduleZrNumArr` to string (string returned from `actionGetMasterZrGsp` action ) to avoid duplicates with `ZrNummer` on frontend
        // console.log('currentZrs :>> ', currentZrs);
        let diff = this.zrNumberArrWithMaster.filter((x: any) => !currentZrs.includes(x));
        // console.log('diff :>> ', diff);

        this.addRolesToExisting(diff);
      }
      if (this.moduleZrNumArr.length) {
        // TODO: specify from Chaslau what to do if changes in Module isCommon status
      }

      this.checkIfNewModulesExistForService(modules);

    } else {
      console.log('zz init :>> ', modules);

      this.initNewData(modules);
    }
  }

  // (AD-222) It is necessary to check whether new modules exist for the specified service. If a module was added after the data was saved to JSON (`GspUserRoleDetails` table `RoleDetails` column), then the data read from JSON would not include the new module, and it would not be visible for the service.
  private checkIfNewModulesExistForService(modules: any) {

    //#region (AD-266) tooltip for `GspModule`
    // lookup map (for performance)
    const moduleMap = new Map(modules.map((m: any) => [m.id, m]));
    // (ADD-266) add `Tooltips` for existing items
    this.moduleZrNumArr.forEach((row: any) => {
      row.moduleRoles?.forEach((dbModule: any) => {
        const match: any = moduleMap.get(dbModule.id);
        if (match) {
          dbModule.name = match.name; // Replace the stale name saved in RoleDetails with the current GspModule name.
          dbModule.tooltip = match.tooltip;
        }
      });
    });
    //#endregion

    const dbRoleDetails1stRowModules = this.moduleZrNumArr[0].moduleRoles;
    const dbRoleDetailsModulesCount = dbRoleDetails1stRowModules?.length ?? 0; // when dealing with multiple rows, each row has the same number of columns. Therefore, for multiple rows (e.g., in ZR-portal), we can check the number of modules ONLY in the first row.
    // console.log('zz22 dbRoleDetailsModules:>> ', dbRoleDetails1stRowModules);
    // console.log('zz22 dbModulesCount:>> ', dbRoleDetailsModulesCount);

    const allModulesForService = modules.map((x: any) => {
      return { id: x.id, name: x.name, isCommon: x.isCommon, roles: x.roles ?? [], tooltip: x.tooltip };
    }); //?.length;

    if (dbRoleDetailsModulesCount < allModulesForService?.length) {
      const dbRoleDetailsModulesIds = dbRoleDetails1stRowModules?.map((x: any) => x.id) ?? [];
      const allModulesIds = allModulesForService?.map((x: any) => x.id);
      console.log('zz dbRoleDetailsModulesIds :>> ', dbRoleDetailsModulesIds);
      console.log('zz allModulesIds :>> ', allModulesIds);

      // find modules that exist in project (`Modules` table) but not exist in `roleDetails` JSON field (`GspUserRoleDetails` table `RoleDetails` column)
      const newModuleIds = allModulesIds.filter((item: any) => !dbRoleDetailsModulesIds.includes(item));

      // For each new module, find its details and add to roleDetails
      newModuleIds.forEach((id: any) => {
        const moduleToAdd = allModulesForService.find((x: any) => x.id === id);
        const targetIndex = allModulesForService.findIndex((x: any) => x.id === id);
        if (moduleToAdd) {
          if (this.rolesWithModuleFilter(moduleToAdd).length === 0) return; // if module has no roles for current service, do not add it to roleDetails (otherwise can have empty module column in UI, which can be confusing for users)
          if (this.isSingleRow) {
            // For single row mode, push directly
            // dbRoleDetails1stRowModules?.push(moduleToAdd);
            // Deep clone the module and its 'roles' array for row isolation!
            const clonedModule = { ...moduleToAdd, roles: [...(moduleToAdd.roles || [])] };
            dbRoleDetails1stRowModules?.splice(targetIndex, 0, clonedModule);
          } else {
            // For multiple rows, push to each module column
            this.moduleZrNumArr.forEach((moduleColumn: any) => {
              const alreadyExists = moduleColumn.moduleRoles?.some((m: any) => m.id === id);
              if (!alreadyExists) {
                // Deep clone the module and its 'roles' array for row isolation!
                const clonedModule = { ...moduleToAdd, roles: [...(moduleToAdd.roles || [])] };
                moduleColumn.moduleRoles?.splice(targetIndex, 0, clonedModule);  // ← was push `moduleColumn.moduleRoles?.push(moduleToAdd);`
              }
            });
          }
        }
      });
    }
  }

  addRolesToExisting(zrs: any) {
    // console.log('zz22 moduleRoles22 :>> ', zrs);
    // Generate the filtered roles once outside the loop since it's the same for all `zrs`
    const moduleRoles = this.buildModuleRoles(this.serviceModules, true, false, 'addRolesToExisting');

    zrs.forEach((el: any, index: number) => {
      this.moduleZrNumArr.push({
        zrNummer: el.toString().trim(),
        moduleRoles: moduleRoles.map(m => ({ ...m, roles: [...m.roles] }))
      }); // was zrNummerAll which is wrong for multiple zrNummer
    });
  }

  // TODO: (AD-264) ask Chaslau maybe delete OLD `Block* and Spotmarkt` modules from database and remove this method
  hideBlockverrechnungAndSpotMarktForIntranet(modules: any) {
    if (this.service.id == 1) {
      modules = modules.filter((x: any) => !x.name.toLowerCase().includes('blockverrech') && !x.name.toLowerCase().includes('spotmarkt'))
    }
    return modules;
  }

  initNewData(modules: any) {
    console.log('modules :>> ', modules);
    console.log('this.isSingleRow :>> ', this.isSingleRow);

    const moduleRoles = this.buildModuleRoles(modules, true, this.isSingleRow, 'initNewData');
    if (this.isSingleRow) {
      const zrNummerAll = this.zrNumberArr.map((x: any) => x.trim()).join(',');

      this.moduleZrNumArr.push({ zrNummerAll: zrNummerAll, moduleRoles: moduleRoles });
    } else {
      this.zrNumberArrWithMaster.forEach((el: any, index: number) => {
        this.moduleZrNumArr.push({
          zrNummer: el.toString().trim(),
          // Deep clone the modules AND their nested 'roles' arrays for row isolation
          moduleRoles: moduleRoles.map(m => ({ ...m, roles: [...m.roles] }))
        }); // was zrNummerAll which is wrong for multiple zrNummer
      });
    }
  }

  /**
   * Shared method to filter out modules without roles and map them to the required structure.
   * 
   * @param modules - The array of modules to process.
   * @param initRolesFromModule - If true, uses `x.roles ?? []`, otherwise forces `roles: []`.
   * @param isSingleRow - If true, includes the `isCommon` property in the mapped object.
   * @param callerName - Used for the console warning prefix to maintain context.
   */
  private buildModuleRoles(
    modules: any[],
    initRolesFromModule: boolean,
    isSingleRow: boolean = false,
    callerName: string = 'ModuleRoleTable'
  ): any[] {
    return modules
      .filter((x: any) => {
        const hasRoles = this.rolesWithModuleFilter(x).length > 0;
        if (!hasRoles) {
          const key = `${x.id}-${this.service.id}`;
          if (!ModuleRoleTable._warnedModules.has(key)) {
            ModuleRoleTable._warnedModules.add(key);
            console.warn(`[${callerName}] Module "${x.name}" (id: ${x.id}) skipped — no roles configured for service "${this.service.name}" (id: ${this.service.id})`);
          }
        }
        return hasRoles;
      })
      .map((x: any) => {
        const mapped: any = {
          id: x.id,
          name: x.name,
          tooltip: x.tooltip,
          roles: initRolesFromModule ? (x.roles ?? []) : []
        };

        if (isSingleRow) {
          mapped.isCommon = x.isCommon;
        }

        return mapped;
      });
  }



  get gspUserRoleId() {
    return (this.userRole?.id || this.currentRoleDetail?.gspUserRoleId)!;
  }

  conditionsValues: any[] = [];
  userProfile: string = '';

  @authModule.Action('addUpdateVmeApiUser')
  private actionAddUpdateVmeApiUser!: any;

  async blurModuleRoleAutoComplete(item: any) {
    console.log('blur blurModuleRoleAutoComplete item :>> ', item);

    if (this.conditionsValues.length > 0) {
      await this.updateVmeApiUser();
    }

  }

  private async updateVmeApiUser() {
    const payload = {
      loginName: `${this.zrNumberArr[0]}-${GeneralUtils.generateRandomLetters()}`,
      fullName: `${this.contactData.firstName} ${this.contactData.lastName}`,
      email: this.contactEmail,
      userProfile: this.userProfile,
      data: this.conditionsValues,
    };

    try {
      await this.actionAddUpdateVmeApiUser(payload);
      this.conditionsValues = []; // clear to avoid duplicate requests with same data on next blur event from another module role change (not `Konditionen`)
    } catch (error) {
      logger.error('blurModuleRoleAutoComplete: Failed to add/update VME API user ', error);
    }
  }



  private readonly sharepointRoleIds: number[] = [4, 7, 8, 9, 10, 11, 12, 13, 14];

  // (AD-277) Local state tracker to ensure each rapid-click request calculates 
  //    correct differences based on the PREVIOUS user action, not stale backend data (otherwise can send 3-4 requests for 5 clicks)
  private pendingRolesMap: Record<string, number[]> = {};

  private getPendingRolesMapKey(zr: string | undefined, moduleId: number): string {
    return zr ? `${zr}-${moduleId}` : `${moduleId}`;
  }

  private getInitialPrevRolesForRow(zr: string | undefined, moduleId: number): number[] {
    if (!zr) {
      const initialModule = (this.currentRoleDetailInit?.roleDetails[0] as any)
        ?.moduleRoles?.find((m: any) => m.id === moduleId);

      return initialModule?.roles ? [...initialModule.roles] : [];
    }

    // check if Row exist, for dynamically added multi-ZR row will be `undefined`
    const initialRow = (this.currentRoleDetailInit?.roleDetails as any[])?.find(
      (r: any) => r.zrNummer === zr
    );

    const initialModule = initialRow?.moduleRoles?.find(
      (m: any) => m.id === moduleId
    );

    // If initialModule exists, use its old roles.
    // If it's a dynamically added row, initialModule will be undefined, so force an empty array [].
    const prevRoles = initialModule?.roles ? [...initialModule.roles] : [];

    // If dynamically added row → return empty array
    return prevRoles;
  }

  // Template calls this method on @change
  async changeModuleRole(
    newRoles: number[],
    item: GspUserRoleDetailModuleRole,
    zr: string | undefined
  ) {
    const moduleId = item.id!; // identify which module to change
    const pendingKey = this.getPendingRolesMapKey(zr, moduleId);

    // If we don't have a tracker for this row+module yet, initialize it with current state
    if (!this.pendingRolesMap[pendingKey]) {
      const initialRoles = this.getInitialPrevRolesForRow(zr, moduleId);
      // Use spread operator [...] to create a COPY of the array to "freeze" the state at this moment in time.
      this.pendingRolesMap[pendingKey] = [...initialRoles];
    }

    // // Capture the "BEFORE" state for THIS click to correctly calculate difference + COPY array to avoid mutation
    //   let prevSnapshot: number[];

    // if (this.service?.key === GspServiceKey.ZrPortal) {
    //   // (AD-289) point 3 -- fix bugs not sending backend request for dynamic rows in `ZrPortal` service 
    //   prevSnapshot = this.getInitialPrevRolesZrPortal(zr!, moduleId);
    // } else {
    //   prevSnapshot = [...(this.pendingRolesMap[moduleId] || [])];
    // }
    const prevSnapshot = [...(this.pendingRolesMap[pendingKey] || [])];

    // Capture the "AFTER" state for THIS click. `newRoles` is provided by the UI (v-model), what user just selected
    const nextSnapshot = [...newRoles];

    // Update the tracker IMMEDIATELY for the NEXT click, to avoid see the same `prev` state for VERY FAST clicks
    // Without this immediate update, Clicks 2 and 3 would both see prev=[] → so 1 request missing (no difference)
    this.pendingRolesMap[pendingKey] = [...nextSnapshot];

    // Update UI at once for responsiveness (optimistic update)
    item.roles = nextSnapshot;

    // // (AD-277) Prevent error when quickly click roles many times add and have multiple requests at once, add them in queue and fire each request every 350 ms
    GeneralUtils.queueCall((isLast: boolean) =>
      // nextSnapshot: What the user wants the roles to be AFTER this click
      // prevSnapshot: What the roles were BEFORE this click (from our tracker)
      this.processModuleRoleChange(nextSnapshot, prevSnapshot, item, zr, isLast),
      this.queueConfig.betweenDelay, this.queueConfig.initialDelay);
  }

  async processModuleRoleChange(newRoles: number[],
    prevRoles: number[], // Use the snapshot passed from changeModuleRole
    item: GspUserRoleDetailModuleRole, /*modPosIndex: number,*/ zr: string | undefined, isLastInQueue: boolean) {
    // console.log('newRoles :>> ', newRoles);
    console.log('newRoles :>> ', newRoles);
    console.log('newRolesitem :>> ', item);
    console.log('zr :>> ', zr);
    // console.log('this.isVmeAcademyService :>> ', this.isVmeAcademyService);
    // console.log('this.isMaxService :>> ', this.isMaxService);

    this.updateIsProcessingRoles(true);

    // const previousItemState = this.currentRoleDetailInit?.roleDetails as GspUserRoleDetailInner[];
    // const freshState = await this.fetchFreshRoleState(item.id!, zr);
    // console.log('freshState :>> ', freshState);
    // let prev = (freshState?.roleDetails[0] as any)?.moduleRoles?.find((x:any) => x.id == item.id);
    // console.log('fresh prev :>> ', prev);
    // console.log('fresh prev roles :>> ', prev.roles);
    console.log('fresh newRoles :>> ', newRoles);
    console.log('fresh prevRoles :>> ', prevRoles);
    // // let prev: GspUserRoleDetailModuleRole | null | undefined = null;

    // if (previousItemState) {
    //   for (let roleDetail of previousItemState) {
    //     if (roleDetail.zrNummer != zr) continue;

    //     let found = roleDetail.moduleRoles?.find((x) => x.id == item.id);
    //     if (found != undefined) {
    //       prev = found;
    //       break;
    //     }
    //   }
    // }

    // let operation = '';
    // let difference: number[] = [];
    // // if (!prev?.roles || newRoles.length > prev.roles?.length) {
    // if (newRoles.length > prevRoles.length) {
    //   operation = RoleOperation.add;
    //   difference = newRoles.filter((x: any) => !prev?.roles?.includes(x));
    // } else {//(!!prev?.roles) {
    //   // console.log('prev.roles?.lengths - ev.length > 1 :>> ', prev.roles?.length - ev.length);
    //   operation = prev.roles?.length - newRoles.length > 1 ? RoleOperation.deleteAll : RoleOperation.delete;
    //   difference = prev.roles.filter((x: any) => !newRoles.includes(x));
    // }
    let operation = '';
    let difference: number[] = [];

    // USE THE ARGUMENTS PASSED IN:
    if (newRoles.length > prevRoles.length) {
      operation = RoleOperation.add;
      // Compare newSnapshot vs oldSnapshot
      difference = newRoles.filter(x => !prevRoles.includes(x));
    } else {
      operation = (prevRoles.length - newRoles.length > 1) ? RoleOperation.deleteAll : RoleOperation.delete;
      difference = prevRoles.filter(x => !newRoles.includes(x));
    }
    console.log('zz operation :>> ', operation);

    //#region (AD-267) Single select of role for `ManageMax`
    // !! (AD-267) place this code after `operation` logic to have `ADD` operation when we remove 1 role, otherwise `operation == DELETE` and wrong logic executed
    // For `managemax` module Allow to select only 1 role from 2
    if (item.id === 23 && newRoles.length > 1) {
      // Keep only the last selected role (last item in array)
      const latestRoleId = newRoles[newRoles.length - 1];
      newRoles = [latestRoleId];

      item.roles = newRoles; // Update the v-model immediately to reflect in UI
    }
    //#endregion

    // (AD-277) allow `SignalR` to fire on last Role processing
    if (isLastInQueue) {
      this.updateIsProcessingRoles(false);
    }

    let isProcessOnly1stIteration = false;

    for (let roleId of difference) {
      if (isProcessOnly1stIteration) break;
      let roleDetailsModel = gsp.parse({});

      if (this.currentRoleDetail?.id) {
        console.log('this.currentRoleDetail?.id :>> ', this.currentRoleDetail?.id);
        roleDetailsModel = this.currentRoleDetail;
      }
      // if (!this.userRole?.id) {
      roleDetailsModel.contactId = this.contactId;
      roleDetailsModel.contactEmail = this.contactEmail;
      // }
      roleDetailsModel.actionType = operation;
      roleDetailsModel.roleId = roleId;

      if (operation == RoleOperation.deleteAll) {
        let roleNames = this.roles.filter((x: any) => prevRoles?.includes(x.id)).map((x: any) => x.name); // (AD-277) was `prev?.roles;`
        roleDetailsModel.roleName = `(${roleNames.length} roles) ${roleNames.join(',')}`;
        isProcessOnly1stIteration = true;
      } else {
        // The typescript compiler seems to be buggy here, so I needed to mark these variables as any.
        let role = this.roles.find((x: any) => x.id == roleId);
        roleDetailsModel.roleName = (role as any).name ?? '';
      }

      roleDetailsModel.moduleId = item.id!;
      roleDetailsModel.isCommonModule = item.isCommon!;

      // console.log('aaaa object this.moduleZrNumArr :>> ', Object.assign({},this.moduleZrNumArr));

      // console.log('rolesCount :>> ', rolesCount);
      roleDetailsModel.roleDetails = this.moduleZrNumArr;
      roleDetailsModel.gspUserRoleId = this.gspUserRoleId;
      roleDetailsModel.serviceId = this.service.id;
      roleDetailsModel.zrNummer = zr;

      roleDetailsModel.contactAzureId = this.contactData.contactAzureId;
      roleDetailsModel.prevRoles = prevRoles; // (AD-277) was `prev?.roles;`
      roleDetailsModel.roleDiff = difference;
      console.log('difference :>> ', difference);
      // roleDetailsModel.modulesEntraGroups = item.isCommon ? this.commonModules.find((x:any)=> x.id == item.id)?.entra_Group : this.serviceModules.find((x:any)=> x.id == item.id)?.entra_Group;

      // blur autocomplete
      console.log('roleDetailsModel :>> ', roleDetailsModel);
      console.log('roleDetailsModel  this.service:>> ', this.service);
      console.log('this.intranetKonditionModule :>> ', this.intranetKonditionModule);
      console.log('this.in :>> ', this.intranetKonditionModule?.id == roleDetailsModel.moduleId);
      await this.actionUpdateGspUserRoleDetail(roleDetailsModel)
        .then((result: any) => {

          if (this.sharepointRoleIds.includes(roleDetailsModel.roleId)) {

            const payload = {
              isProcessSingleRecord: true,
              action: roleDetailsModel.actionType,
              roleId: roleDetailsModel.roleId,
              email: this.contactEmail,
              zrNummer: roleDetailsModel.roleId == 4 ? this.zrNumberArr?.join(',') + '' : null, // only for role with id 4 `chef` (as discussed with Chaslau, since only this role requires ZrNummer for SharePoint groups)
            }
            this.actionSyncSharepointGroups(payload);
          }

          console.log('change ModuleRole actionUpdateGspUserRoleDetail result :>> ', result);
          this.currentRoleDetail = gsp.parse(result.result);
          this.currentRoleDetail.gspUserRole = null; // avoid  error when select multiple Roles for nonexisting `UserRole` (or need `parse` `UserRole` model)

          this.currentRoleDetailInit = deepClone(gsp.parse(result.result)); // was `Object.assign({}, gsp.parse(result.result))` but it is not deep clone and nested objects are still linked to original ones, which cause bugs when compare initial state with current state after multiple changes in UI (e.g., select role A, then select role B → when compare initial state with current state for role A, it shows no difference, because initial state was mutated after select role B)

          // (AD-250) did not get external API config, so comment it until get data to call external API on specific role change
          // TODO: (AD-250) uncomment when get API config for changes (only for `Konditionen` module changes)
          if (this.intranetKonditionModule?.id == roleDetailsModel.moduleId) {
            console.log('this.moduleZrNumArr :>> ', this.moduleZrNumArr);
            var roleIds = this.moduleZrNumArr[0].moduleRoles?.find((x: any) => x.id == roleDetailsModel.moduleId)?.roles ?? [];

            console.log('zz this.moduleZrNumArr roles :>> ', this.moduleZrNumArr[0].moduleRoles?.find((x: any) => x.id == roleDetailsModel.moduleId)?.roles);

            var roleProfiles = roleIds.map(id => this.vmeRoles.find(r => r.id === id)?.key)
              .filter(Boolean).join(',');
            console.log('zzz  roleProfiles:>> ', roleProfiles);
            this.userProfile = roleProfiles;
            var currentRoleProfileName = this.vmeRoles.find(r => r.id === roleId)?.key ?? '';

            let hasValue = this.conditionsValues.find(x => x.email == this.contactEmail && x.roleId == roleDetailsModel.roleId && x.moduleId == roleDetailsModel.moduleId);
            console.log('ccc hasValue :>> ', hasValue);
            if (roleDetailsModel.actionType == RoleOperation.add) {


              console.log('ccchasValue add :>> ', hasValue);

              if (hasValue) {
                const index = this.conditionsValues.findIndex(user => user.email == this.contactEmail && user.roleId == roleDetailsModel.roleId && user.moduleId == roleDetailsModel.moduleId);
                if (index !== -1) {
                  this.conditionsValues.splice(index, 1);
                }
                // hasValue.action = roleDetailsModel.actionType;
              } else {
                this.conditionsValues.push({ action: roleDetailsModel.actionType, email: this.contactEmail, roleId: roleDetailsModel.roleId, roleName: roleDetailsModel.roleName, moduleId: roleDetailsModel.moduleId, profileName: currentRoleProfileName });


              }

            } else if (roleDetailsModel.actionType == RoleOperation.delete) {

              console.log('ccc hasValue delete :>> ', hasValue);
              if (hasValue) {
                const index = this.conditionsValues.findIndex(user => user.email == this.contactEmail && user.roleId == roleDetailsModel.roleId && user.moduleId == roleDetailsModel.moduleId);
                if (index !== -1) {
                  this.conditionsValues.splice(index, 1);
                }
                // hasValue.action = roleDetailsModel.actionType;
              } else {
                this.conditionsValues.push({ action: roleDetailsModel.actionType, email: this.contactEmail, roleId: roleDetailsModel.roleId, roleName: roleDetailsModel.roleName, moduleId: roleDetailsModel.moduleId, profileName: currentRoleProfileName });
              }

            } else if (roleDetailsModel.actionType == RoleOperation.deleteAll) {
              this.conditionsValues = [];
              this.updateVmeApiUser(); // if delete all
            }
            console.log('ccc zzz conditionsValues :>> ', this.conditionsValues);

          }



          if (this.isMaxService) {
            this.getWarenGruppeAction();
            console.log('roleDetailsModel managemax :>> ');
            if (roleDetailsModel.actionType == RoleOperation.add) {
              const maxPayload = {
                contactId: this.contactId,
                contactEmail: this.contactEmail,
                firstName: this.contactData.firstName,
                lastName: this.contactData.lastName,
                UserGroupId: this.manageMaxUserGroupId, // 2026-04 (!! change) if `basis` 1, if `admin-` 8 // discussed with Chaslau (for now always 1)
                zrNummernCsv: this.zrNumberArr?.join(',') + '',
                azureUserId: this.contactData.contactAzureId,

                azureGroupId: this.service.entra_Group,

                serviceId: this.service.id,
                gspUserRoleId: this.currentRoleDetail?.id,
                warengruppen: this.warmax,
                // warengruppenWithName: warenWithNames,
                actionType: this.warenBackendAction,
                warenDiff: this.warenDiff
              }
              this.actionAddUserFromManageMaxService(maxPayload);
            } else {
              this.actionDeleteUserFromManageMaxService(
                {
                  contactId: this.contactId, contactEmail: this.contactEmail,
                  azureUserId: this.contactData.contactAzureId,
                  azureGroupId: this.service.entra_Group,
                  gspUserRoleId: this.currentRoleDetail?.id,
                  serviceId: this.service.id,
                  actionType: this.getMaxDeleteWarenAction(),
                  warenDiff: this.warenDiff
                });
              if (!this.isManageMaxHasRole) this.warmax = []; // (AD-197 clear managemax roles)
            }

          }

          else if (item.name && item.name.toLowerCase().includes('spotmarkt')) {
            if (roleDetailsModel.actionType == RoleOperation.add) {
              const primaryCompanyId = +this.contactData.primaryCompany;
              // console.log('this.contactData :>> ', this.contactData);
              // console.log('primaryCompanyId :>> ', primaryCompanyId);
              this.actionGetCompany(primaryCompanyId).then((result: any) => {
                console.log('company result :>> ', result);
                let company = result;
                const defaultCountry: Country = CountryUtils.findCountry("DE")!;
                const countryId = CountryUtils.findCountry(company.countryRegion)?.id ?? defaultCountry.id;


                const newCustomerId = GeneralUtils.generateShopwareUUID();
                const billingId = GeneralUtils.generateShopwareUUID();
                const shippingId = GeneralUtils.generateShopwareUUID();

                const customerPayloadJson: any = {
                  addresses: [{
                    'id': billingId,
                    'firstName': '__',
                    'lastName': '__',
                    'company': company.companyname,
                    'street': company.streetAddress,
                    'city': company.city,
                    'zipcode': company.postalCode,
                    'countryId': countryId
                  },
                  {
                    'id': shippingId,
                    'firstName': '__',
                    'lastName': '__',
                    'company': company.companyname,
                    'street': company.streetAddress,
                    'city': company.city,
                    'zipcode': company.postalCode,
                    'countryId': countryId
                  }],
                  'id': newCustomerId,
                  'firstName': this.contactData.firstName,
                  'lastName': this.contactData.lastName,
                  'email': this.contactEmail,
                  'customerNumber': company.zrNummer,
                  'company': company.companyname,
                  'groupId': '0198c7c6eacc73ddabb0865b6e2d936d',
                  'salesChannelId': '019523bfc9e77764a3373ddc1bafdb18',
                  'languageId': '0194f5c317e673168b59b25c7f5514cc',
                  'defaultBillingAddressId': billingId,
                  'defaultShippingAddressId': shippingId,
                  'defaultPaymentMethodId': '0197a6f28afe77af91a0c5e23c4c4633',
                  'accountType': 'business',
                  'customFields': {
                    'custom_identifier_user_entraid_': this.contactData.contactAzureId
                  },

                }
                console.log('customerPayloadJson :>> ', customerPayloadJson);



                const customerAddPayload = {
                  customerBody: JSON.stringify(customerPayloadJson),
                  actionType: RoleOperation.add.toLowerCase(),
                  customerId: newCustomerId,
                  zrNummer: company.zrNummer,
                  azureUserId: this.contactData.contactAzureId,
                  contactData: `ID: ${this.contactId} Name: ${this.contactData.firstName}  ${this.contactData.lastName}`,
                }
                this.actionAddCustomer(customerAddPayload);

              }).catch((err: any) => {

              });


            } else {
              // console.log('roleDetailsModel.actionType :>> ', roleDetailsModel.actionType);
              const customerDeletePayload = {
                azureUserId: this.contactData.contactAzureId,
                actionType: RoleOperation.delete.toLowerCase(),
              }
              this.actionDeleteCustomer(customerDeletePayload);

            }
          }

          if (!this.userRole?.id) {
            let payload = result.result.gspUserRole;
            payload.gspUserRoleDetails = [this.currentRoleDetail];
            this.actionAddRoleFromBackend(payload).then((result: any) => {
              this.handleContactPanelForZrBi(roleDetailsModel.actionType);
              this.handleVmeCommunitySwitchIfDisabledAndHaveRoles();
            });
          } else {
            this.actionAddRoleDetailFromBackend(result.result).then((result: any) => {
              this.handleContactPanelForZrBi(roleDetailsModel.actionType);
              this.handleVmeCommunitySwitchIfDisabledAndHaveRoles();
            });
          }
        })
        .catch((err: any) => {
          // (AD-260) if any error revert changes in UI (checked/unchecked role) to avoid mismatch between frontend and backend data (no user in `tbl_sync_testuser` for Staging ENV for example)
          this.$nextTick(() => {
            for (let roleDetail2 of this.currentRoleDetail?.roleDetails as GspUserRoleDetailInner[] ?? []) {
              let found = roleDetail2.moduleRoles?.find((x) => x.id == item.id);
              if (found != undefined) {
                found.roles = prevRoles ?? [];
                break;
              }
            }
          })

          logger.error(err);
        });

      this.$emit('click:saveChangeModuleRole', this.contactId);
    }

  }

  handleVmeCommunitySwitchIfDisabledAndHaveRoles() {
    // console.log('zzz handleVmeCommunitySwitchIfDisabled freigabeVmeCommunity :>> ', this.contactData.freigabeVmeCommunity);
    console.log('zzz this.moduleZrNumArr[0].moduleRoles :>> ', this.moduleZrNumArr[0].moduleRoles);

    if (this.isVmeCommunityService) {
      const serviceHasRoles = this.moduleZrNumArr[0].moduleRoles && (this.moduleZrNumArr[0].moduleRoles as any)[0].roles?.length > 0;
      // console.log('zzz (this.moduleZrNumArr[0].moduleRoles as any).roles :>> ', (this.moduleZrNumArr[0].moduleRoles as any)[0].roles);
      // console.log('zzz servicehasroles :>> ', serviceHasRoles);
      if (serviceHasRoles && !this.contactData.freigabeVmeCommunity) {
        this.$emit('add:vme-community-group')
      }
    }
  }

  handleContactPanelForZrBi(actionType?: any) {
    if (!this.isZrBiService) {
      return;
    }

    if (this.hasAnySelectedRoles()) {
      this.actionUpdateContactPanel({ email: this.contactEmail, isZrBiActive: true, manualCategoriesAndDocTypesUpdate: true });
      return;
    }

    if (!actionType || actionType == RoleOperation.delete || actionType == RoleOperation.deleteAll) {
      this.actionDeleteContactPanel(this.contactEmail);
    }
  }

  changeRoleValue() {
    //this.$emit('click:saveChangeModuleRole', this.contactId);
  }

  //#region
  isSaving = false;
  userRolesPayload: any = [];

  boxes: Array<boolean> = [false];
  roleBoxes: Array<any> = [];
  userRoleData = [];

  // get userRole() {
  //   // const result = this.userRoles.items.find((role: any) => role.contactEmail == this.contact.email);
  //   const result: any = '';
  //   return result;
  // }

  get roles(): GspRole[] {
    var serviceRoles = this.gspRoles.items.filter((r: any) => r.rolesDataServiceIds.includes(this.service.id));
    return serviceRoles;
    return this.gspRoles.items;
  }
  /// Role for `ZrPortal` supplier
  get leserechteRoleId() {
    var leserechteRole = this.roles.find((r: any) => r.name.toLowerCase().includes('leserecht'));
    // console.log('zzz55 leserechteRole :>> ', leserechteRole);
    return leserechteRole?.id;
  }
  /// Role for `ZrPortal` member
  get vollzugriffRoleId() {
    var vollzugriffRole = this.roles.find((r: any) => r.name.toLowerCase().includes('zugrif'));
    // console.log('zzz55 vollzugriffRole :>> ', vollzugriffRole);
    return vollzugriffRole?.id;
  }
  // (AD-222) NOT show all roles but only roles that has setup for corresponding module in `Roles` table/form, (discussed with Chaslau) if NO setup in `Roles` form then show `EMPTY RESULT` for module (for example, new module)
  rolesWithModuleFilter(item2: any, applyMarkenportfolioGate: boolean = true): GspRole[] {
    //  console.log('zz item2 :>> ', item2);
    // console.log('zz rolesWithModuleFilter :>> ', );
    // console.log('zz this.gspRoles :>> ',  this.gspRoles);
    var serviceRoles = this.roles;
    // console.log('zz OA serviceRoles :>> ', Object.assign({},serviceRoles));
    // console.log('zzz item2.name.split(',').length :>> ',  item2.name.split(',').length);
    // (AD-222) (point 3) strange bug that from ~ 3500 records from `GspUserRoleDetails` table for service `Intranet` ("ServiceId" = 1) ~ 650 records have `isCommon` field in JSON field and the rest 2850 records do NOT have this field at all
    // (AD-222) (point 3) so as a workaround we check `name` of modules and if it is common module then `name` will be a concatenation of multiple module names, so if `name` contains 2 or more commas (`,`) we consider module as COMMON
    if (item2.isCommon || (item2.isCommon === undefined && item2.name.split(',').length > 2)) {
      serviceRoles = serviceRoles.filter((r: any) => r.rolesData.some((x: any) => x.serviceId == this.service.id && x.module.isCommon))
      // (AD-222) (point 3) if Common module does not have `isCommon` field in JSON set it to TRUE (and save on any change)
      if (item2.isCommon === undefined) {
        item2.isCommon = true;
      }
    } else {
      serviceRoles = serviceRoles.filter((r: any) => r.rolesData.some((x: any) => x.serviceId == this.service.id && !x.module.isCommon && x.moduleId == item2.id))
    }

    // (2026-10) !! if need to ignore filtering logic, pass `FALSE` parameter `false` = `rolle_markenportfolio_allgemein` gating must NOT hide modules
    // (AD-313) IMPORTANT: filter the autocomplete VALUES (roles), NOT the module columns.
    // (AD-313) If `serviceId == 1` (this table is `Intranet & Konditionsverwaltung`) OR the role `rolesDataServiceIds` contains 1,
    // then values with `Roomio` in `name` (case insensitive) are shown only if `rolle_markenportfolio_allgemein`
    // contains `roomio` (ignore casing) - same for `Trendhopper`.
    // `applyMarkenportfolioGate = false` is used by the module-visibility checks (`length > 0` calls), so the
    // modules themselves are NEVER hidden by this gating.
    if (applyMarkenportfolioGate) {
      serviceRoles = serviceRoles.filter((r: any) => {
        // Exact match for '1' to avoid matching '10', '21', etc.
        const hasService1 = typeof r.rolesDataServiceIds === 'string'
          ? r.rolesDataServiceIds.split(',').map((s: string) => s.trim()).includes('1')
          : (r.rolesDataServiceIds ?? []).includes(1);

        const isService1Role = this.service.id == 1 || hasService1;

        if (!isService1Role) return true;
        const roleName = (r.name ?? '').toLowerCase();
        if (roleName.includes('roomio')) return this.showRoomioRoles;
        if (roleName.includes('trendhopper')) return this.showTrendhopperRoles;
        return true;
      });
    }

    return serviceRoles;
  }

  not(e: any) {
    e.preventDefault();
    e.stopPropagation();

    console.log('e :>> ', e);
  }

  changeZrNumbBox(ev: any, item: any, i: any) {
    console.log('ev :>> ', ev);
    console.log('item :>> ', item);
    console.log('i :>> ', i);
    console.log('this.gspRoles :>> ', this.gspRoles);
    if (!ev) {
      this.removeZrNumRole('zrNum', i);
    }
  }

  removeZrNumRole(source: any, index: number) {
    this.userRolesPayload[index] = null;
    if (source == 'zrNum') {
      Vue.set(this.roleBoxes, index, null);
    }
  }

  changeRole(ev: any, item: any, i: any) {
    if (ev.length == 0) {
      this.removeZrNumRole('role', i);
    }
    console.log('ev :>> ', ev);
    console.log('item :>> ', item);
    console.log('i zr :>> ', i);

    let obj = { zrNummer: item.trim(), roles: ev };
    this.userRolesPayload[i] = obj;
    // this.boxes[i] = ev.length>0 ;
    Vue.set(this.boxes, i, ev.length > 0);

    // Array.prototype.splice
    // vm.items.splice(indexOfItem, 1, newValue)
  }

  save() {
    console.log('save roles:>> ');

    // const payload = {
    //   id: this.userRole?.id || undefined,
    //   contactId: this.contact.recordID,
    //   contactEmail: this.contact.email,
    //   zrNumRolesData: JSON.stringify(this.userRolesPayload),
    // };
    // console.log('payload :>> ', payload);

    // this.actionUpdateGspUserRole(payload);
  }
  //#endregion

  // (AD-223) method called from `contact-panel` parent component via REF when `Freigabe erteilt` switch for `ZrPortal` is changed
  private setFromParentSupplierSwitchZrPortal(isDelete: boolean) {
    console.log('zzz setFromParentSupplierSwitchZrPortal:>> isDelete', isDelete); //this.roles
    // console.log('zzz editedInnerUserRoleDetails this.moduleZrNumArr OA :>> ', Object.assign({}, this.moduleZrNumArr));

    if (!!this.leserechteRoleId) {
      this.moduleZrNumArr.forEach((element) => {
        element.moduleRoles?.forEach((module) => {
          if (isDelete) {
            module.roles = [];
          } else {
            module.roles = [this.leserechteRoleId!];
          }
        })
      });
      this.onEditMultipleModuleRolesDialogSave(this.moduleZrNumArr);
    } else if (!!this.vollzugriffRoleId) {
      this.moduleZrNumArr.forEach((element) => {
        element.moduleRoles?.forEach((module) => {
          if (isDelete) {
            module.roles = [];
          } else {
            module.roles = [this.vollzugriffRoleId!];
          }
        })
      });
      this.onEditMultipleModuleRolesDialogSave(this.moduleZrNumArr);
    } else {
      logger.error('Cannot calculate/find `ID` for `leserechte` or `vollzugriffRoleId` role')
    }

  }
  private setFromParentSupplierSwitchVmeCommunity(isDelete: boolean) {
    console.log('zzz setFromParentSupplierSwitchVmeCommunity:>>  isDelete', isDelete);
    console.log('zzz editedInnerUserRoleDetails this.moduleZrNumArr OA :>> ', Object.assign({}, this.moduleZrNumArr));
    console.log('this.leserechteRoleId :>> ', this.leserechteRoleId);
    let modules = Object.assign({}, this.moduleZrNumArr);
    let module = modules[0].moduleRoles ? modules[0].moduleRoles[0] : null;
    // (module[0]). = [];


    if (isDelete && module) {
      module.roles = []; // delete all roles for `singleRow`
      this.changeModuleRole([], module, undefined);
    } else {
      logger.error('Cannot delete roles for `Vme-Community`')
    }

  }

  // (AD-305) Updates all comboboxes for ZrStatNew in memory and executes 1 single bulk save request (instead of 7 individual requests from test value) 
  private setFromParentSwitchZrStatNew(isDelete: boolean) {
    // console.log('zzz setFromParentSwitchZrStatNew:>> isDelete', isDelete);

    this.moduleZrNumArr.forEach((row) => {
      row.moduleRoles?.forEach((module: any) => {
        if (isDelete) {
          module.roles = [];
        } else {
          const availableRoles = this.rolesWithModuleFilter(module);
          module.roles = availableRoles.map((r: any) => r.id);
        }
      });
    });

    // Reset pending tracker map to avoid stale diff snapshots
    this.pendingRolesMap = {};

    // Execute 1 single bulk update request for all rows/modules
    this.onEditMultipleModuleRolesDialogSave(this.moduleZrNumArr);
  }

  private onEditMultipleModuleRoles() {
    this.editMultipleModuleRolesDialog.editedUserRoleDetails = deepClone(this.moduleZrNumArr);
    this.editMultipleModuleRolesDialog.dialog = true;
  }

  private onEditMultipleModuleRolesDialogClose() {
    this.editMultipleModuleRolesDialog.dialog = false;
  }

  private async onEditMultipleModuleRolesDialogSave(editedInnerUserRoleDetails: GspUserRoleDetailInner[]) {
    this.editMultipleModuleRolesDialog.dialog = false;
    const newRoleDetails = this.moduleZrNumArr;
    for (let innerUserRoleDetail of editedInnerUserRoleDetails) {
      if (innerUserRoleDetail.moduleRoles == undefined) continue;

      for (let moduleRole of innerUserRoleDetail.moduleRoles) {
        const moduleRoleInNewRoleDetails = newRoleDetails
          .find((x) => x.zrNummer == innerUserRoleDetail.zrNummer)
          ?.moduleRoles?.find((x) => x.name == moduleRole.name);
        if (moduleRoleInNewRoleDetails != undefined) moduleRoleInNewRoleDetails.roles = moduleRole.roles;
      }
    }

    const userRoleDetailToUpdate = <GspUserRoleDetail>{ ...this.currentRoleDetail };
    userRoleDetailToUpdate.roleDetails = newRoleDetails;
    userRoleDetailToUpdate.contactId = this.contactId;
    userRoleDetailToUpdate.serviceId = this.service.id;
    userRoleDetailToUpdate.contactAzureId = this.contactData?.contactAzureId;


    // Structure needed to add a log entry for each changed module role.
    let moduleRoleChanges: {
      ContactId: number;
      ServiceId: number;
      ContactEmail: string;
      ActionType: UserActionType;
      RoleId?: number;
      ModuleId?: number;
      IsCommonModule?: boolean;
      RoleName: string;
      ZrNummer?: string;
    }[] = [];
    //this.currentRoleDetailInit = deepClone(userRoleDetailToUpdate);
    // Figure out what has changed and create respective log entries
    //let oldRoleDetails: GspUserRoleDetailInner[];

    if (this.currentRoleDetailInit != undefined) {
      const oldRoleDetails = this.currentRoleDetailInit!.roleDetails as GspUserRoleDetailInner[];
      for (let oldRoleDetail of oldRoleDetails) {
        let newRoleDetail = newRoleDetails.find((x) => x.zrNummer == oldRoleDetail.zrNummer);
        for (let oldModuleRole of oldRoleDetail.moduleRoles ?? []) {
          let newModuleRole = newRoleDetail?.moduleRoles?.find((x) => x.id == oldModuleRole.id);
          let addedModuleRoles = newModuleRole?.roles?.filter((x) => !oldModuleRole.roles?.includes(x));
          let deletedModuleRoles = oldModuleRole.roles?.filter((x) => !newModuleRole?.roles?.includes(x));
          for (let addedModuleRole of addedModuleRoles ?? []) {
            moduleRoleChanges.push({
              ContactId: this.contactId,
              ServiceId: userRoleDetailToUpdate.serviceId,
              ContactEmail: this.contactEmail,
              ActionType: 'Add',
              RoleId: addedModuleRole,
              ModuleId: newModuleRole?.id,
              IsCommonModule: newModuleRole?.isCommon,
              RoleName: this.roles.find((x: any) => x.id == addedModuleRole)?.name ?? '-',
              ZrNummer: newRoleDetail?.zrNummer,
            });
          }
          for (let deletedModuleRole of deletedModuleRoles ?? []) {
            moduleRoleChanges.push({
              ContactId: this.contactId,
              ServiceId: userRoleDetailToUpdate.serviceId,
              ContactEmail: this.contactEmail,
              ActionType: 'Delete',
              RoleId: deletedModuleRole,
              ModuleId: newModuleRole?.id,
              IsCommonModule: newModuleRole?.isCommon,
              RoleName: this.roles.find((x: any) => x.id == deletedModuleRole)?.name ?? '-',
              ZrNummer: newRoleDetail?.zrNummer,
            });
          }
        }
      }
    }
    else {

      for (let newRoleDetail of editedInnerUserRoleDetails) {

        for (let newdModuleRole of newRoleDetail.moduleRoles ?? []) {
          let newModuleRole = newRoleDetail?.moduleRoles?.find((x) => x.id == newdModuleRole.id);
          let addedModuleRoles = newModuleRole?.roles;
          for (let addedModuleRole of addedModuleRoles ?? []) {
            moduleRoleChanges.push({
              ContactId: this.contactId,
              ServiceId: userRoleDetailToUpdate.serviceId,
              ContactEmail: this.contactEmail,
              ActionType: 'Add',
              RoleId: addedModuleRole,
              ModuleId: newModuleRole?.id,
              IsCommonModule: newModuleRole?.isCommon,
              RoleName: this.roles.find((x: any) => x.id == addedModuleRole)?.name ?? '-',
              ZrNummer: newRoleDetail?.zrNummer,
            });
          }
        }

      }
    }



    this.currentRoleDetailInit = deepClone(userRoleDetailToUpdate);

    const payload = {
      userRoleDetail: userRoleDetailToUpdate,
      moduleRoleChanges: moduleRoleChanges,
      contactId: this.contactId,
      contactAzureId: this.contactData?.contactAzureId,
      serviceId: this.service.id,
    };
    await this.actionUpdateGspUserRoleDetailMultipleRoles(payload)
      .then((result: any) => {
        if (!this.userRole?.id) {
          console.log('result.result.gspUserRole :>> ', result.result.gspUserRole);
          let payload = result.result.gspUserRole;
          payload.gspUserRoleDetails = [this.currentRoleDetail];
          this.actionAddRoleFromBackend(payload).then(() => {
            // this.handleContactPanelForZrBi();
          });
        } else {
          this.actionAddRoleDetailFromBackend(result.result).then(() => {
            // this.handleContactPanelForZrBi();
          });
        }
      })
      .catch((err: any) => {
        logger.error(err);
      });

    // (AD-305) Trigger parent contact-panel to reload active service counts
    this.$emit('click:saveChangeModuleRole', this.contactId);
  }

  getNameCompany(zrnumer: string, zrnumerAll: string) {
    let valueZRNummer: string = '';

    if (zrnumer != undefined && zrnumer.toString().length != 0) {
      valueZRNummer = zrnumer.toString().trim();
    } else if (zrnumerAll != undefined && zrnumerAll.toString().length != 0) {
      valueZRNummer = zrnumerAll.toString().trim();
    }
    let companyName = this.companyZrNums.items.find((x: any) => x.zrNummer == valueZRNummer)?.companyName;
    return companyName;
  }
}